export const T = {
  en_GB: {
    expand: "Expand",
    title: "Agent Scheduler",
    empty: "No scheduled agents yet",
    new: "New scheduled agent",
    name: "Name",
    prompt: "Prompt",
    schedule: "Schedule",
    model: "Model",
    timeoutMin: "Timeout (minutes)",
    save: "Save",
    cancel: "Cancel",
    runNow: "Run now",
    pause: "Pause",
    resume: "Resume",
    edit: "Edit",
    delete: "Delete",
    deleteConfirm: "Delete this scheduled agent and its run history?",
    once: "Once",
    daily: "Daily",
    weekly: "Weekly",
    hourly: "Hourly",
    interval: "Every N minutes",
    weekday: "Weekday",
    time: "Time",
    minutePastHour: "Minute past hour",
    intervalMin: "Interval (minutes)",
    nextRun: "Next run",
    lastRun: "Last run",
    runs: "Runs",
    openThread: "Open thread",
    noRuns: "No runs yet",
    statusActive: "Active",
    statusRunning: "Running",
    statusQueued: "Queued",
    statusPaused: "Paused",
    statusFailed: "Failed",
    statusCompleted: "Completed",
    chooseModel: "Default model",
    requiredFields: "Name, prompt and a valid schedule are required",
    nonexistentTime: "That time doesn't exist on this date (daylight saving change)",
    saveError: "Failed to save",
    date: "Date",
    weekdays: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
    dailyAt: (time: string) => `Daily at ${time}`,
    weeklyAt: (day: string, time: string) => `${day} at ${time}`,
    hourlyAt: (minute: string) => `Hourly at :${minute.padStart(2, "0")}`,
    everyMinutes: (n: string) => `Every ${n} min`,
    justNow: "just now",
    ago: (span: string) => `${span} ago`,
    inFuture: (span: string) => `in ${span}`,
  },
  nb_NO: {
    expand: "Utvid",
    title: "Agent-planlegger",
    empty: "Ingen planlagte agenter enda",
    new: "Ny planlagt agent",
    name: "Navn",
    prompt: "Instruks",
    schedule: "Tidsplan",
    model: "Modell",
    timeoutMin: "Tidsavbrudd (minutter)",
    save: "Lagre",
    cancel: "Avbryt",
    runNow: "Kjør nå",
    pause: "Pause",
    resume: "Fortsett",
    edit: "Rediger",
    delete: "Slett",
    deleteConfirm: "Slette denne planlagte agenten og kjøringshistorikken?",
    once: "Én gang",
    daily: "Daglig",
    weekly: "Ukentlig",
    hourly: "Hver time",
    interval: "Hvert N minutt",
    weekday: "Ukedag",
    time: "Tidspunkt",
    minutePastHour: "Minutt over hel time",
    intervalMin: "Intervall (minutter)",
    nextRun: "Neste kjøring",
    lastRun: "Sist",
    runs: "Kjøringer",
    openThread: "Åpne tråd",
    noRuns: "Ingen kjøringer enda",
    statusActive: "Aktiv",
    statusRunning: "Kjører",
    statusQueued: "I kø",
    statusPaused: "Pauset",
    statusFailed: "Feilet",
    statusCompleted: "Ferdig",
    chooseModel: "Standardmodell",
    requiredFields: "Navn, instruks og gyldig tidsplan kreves",
    nonexistentTime: "Det tidspunktet finnes ikke på denne datoen (overgang til sommertid)",
    saveError: "Lagring feilet",
    date: "Dato",
    weekdays: ["Man", "Tir", "Ons", "Tor", "Fre", "Lør", "Søn"],
    dailyAt: (time: string) => `Daglig kl. ${time}`,
    weeklyAt: (day: string, time: string) => `${day} kl. ${time}`,
    hourlyAt: (minute: string) => `Hver time, ${minute} min over`,
    everyMinutes: (n: string) => `Hvert ${n}. min`,
    justNow: "akkurat nå",
    ago: (span: string) => `${span} siden`,
    // Same as English: the panel has always shown "in 5m" here.
    inFuture: (span: string) => `in ${span}`,
  },
} as const;
